import React, { Component } from 'react'
import { ProductList, Filter } from '../../../components'
import { CatalogStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'
import ProductTemplates from './Product/ProductTemplates';

 
class Catalog extends Component {
  state = {
    filters: {},
    products: [],
    filterProduct: null,
    filtering: {},
  }

  componentWillReceiveProps({data}) {
    if (data !== this.props.data) {
      this.setState({
        filters: data.categories[Object.keys(data.categories)[0]].filters,
        products: data.pages,
      })
    }
  }

  /** TODO:
   * get better 
   * use reducer 
   */
  getFilters = async (filters) => {
    const product_filters = []
    Object.keys(filters).map((category) => {
      product_filters[category] = []
      this.state.products.map((product) => {
        if(product.filters.models[category]) {
          product.filters.models[category].map((filter) => {
            if (filters[category].indexOf(`${filter}`) !== -1 ) product_filters[category].push(product)
          })
        }
      })
    })

    // const nProduct = product_filters[Object.keys(product_filters)[0]]

    const nProduct = Object.keys(product_filters).reduce((acc, category) => {
      if (acc.length === 0 ) {
        product_filters[category].map((product) => {
          acc.push(product)
        })
      } else {
        acc = product_filters[category].filter((product) => acc.indexOf(product) !== -1)
      }
      return acc
    }, [])

    this.setState({ filterProduct: Object.keys(filters).length > 0 ? nProduct : null })
  }
  
  isFilters = (categories, slug) => {
    const filters = categories.models.filters
    const data = {
      flag: false,
      filters: {}
    }
    Object.keys(filters).map(category => {
      filters[category].map((filter) => {
        const slugify_name = filter.name.toString().toLowerCase().replace('\'','-').replace(/ /g,'-').replace(/[^\w-]+/g,'')
        if (slugify_name === slug) {
          data.flag = true
          data.filters[category] = [filter.name]
        }
      })
    })

    return data
  }
  
  render () {
    const { isReady } = this.props
    const { filters, products } = this.state
    return (
      <div className={`${CatalogStyle} catalog`}>
        <div className={`page-inner transition ${ isReady ? 'transition--ready' : '' }`}>
        {
          filters && Object.keys(filters).length > 0 && (
            <div className="catalog-filter">
              <Filter filters={filters} filtering={this.getFilters} />
            </div>
          )
        }
        {
          products && (
            <div className="catalog-list">
              <ProductList products={ this.state.filterProduct ? this.state.filterProduct : this.state.products } />
            </div>
          )
        }
        </div>
      </div>
    )
  }
}

export default withLoader(Catalog)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Catalog.js